<template>
	<div class="custom-input w-100">





		<div class="d-flex justify-start w-100 mb-1 text-14 weight-500">{{ label }}</div>
		<v-text-field :placeholder="placeholder" class="mt-1 pa-0 w-100 auth-input"
			:class="{ 'error-input-box': hasError }" variant="solo" :type="type" :model-value="modelValue"
			@update:model-value="$emit('update:modelValue', $event)" :error-messages="errorMessages"
			@blur="$emit('blur')" :hide-details="!hasError" :disabled="disabled">


			<template v-slot:message="{ message }">
				<div class="d-flex align-center input-error-container">


					<Warning width="14px" height="14px" class="mr-2" />
					<span>{{ message }}</span>


				</div>
			</template>
		</v-text-field>





	</div>
</template>



<script lang="ts" setup>

import { computed } from "vue";
import Warning from "@/icons/Warning.vue";

const props = defineProps({
	label: {
		type: String,
		required: true,
	},
	placeholder: {
		type: String,
		default: "",
	},
	type: {
		type: String,
		default: "text",
	},
	modelValue: {
		type: [String, Number],
		required: true,
	},
	errorMessages: {
		type: Array as () => string[],
		default: () => [],
	},
	disabled: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(["update:modelValue", "blur"]);

const hasError = computed(() => props.errorMessages.length > 0);

</script>



<style scoped lang="scss">
@use '@/assets/scss/_input-mixins.scss' as input-mixins;
</style>
